<template>
    <div class="despesas">
        <b-table
            :data="despesas"
            class="data-table"
            hoverable
            responsive
            mobile-cards
            :checkable="!idacerto"
            :checked-rows.sync="despesasSelecionadas"
        >
            <b-table-column
                v-for="f in fields"
                :key="f.key + '-' + f.nome"
                :field="f.key"
                :label="$t(f.key)"
                :width="f.key == 'obs' ? 400 : f.width"
                :sortable="f.sortable"
                v-slot="props"
            >
                <div class="obs" v-if="f.key == 'obs'">
                    {{ cutString(props.row.obs, 35) }}
                </div>

                <div v-else-if="f.key == 'data'">
                    {{ props.row.datahorainc | moment("L LT") }}
                </div>

                <div v-else-if="f.key == 'empresa'">
                    <div v-if="props.row.empresa">
                        {{ props.row.empresa.nome}}
                    </div>
                    <div v-else>---</div>
                </div>

                <div v-else-if="f.key == 'distancia'">
                    {{ (props.row.distanciapercorrida / 1000).toFixed(2) }} {{ $t("km") }}
                </div>

                <div v-else-if="f.key == 'odometro'">
                    {{ props.row.odometro }} {{ $t("km") }}
                </div>

                <div v-else-if="f.key == 'placa'">
                    {{ isNull(props.row.placa) ? '---' : props.row.placa }}
                </div>

                <div v-else-if="f.key == 'estabelecimento'">
                    {{ isNull(props.row.estabelecimento) ? '---' : props.row.estabelecimento }}
                </div>

                <div v-else-if="f.key == 'centrocusto'">
                    <span v-if="props.row.centrocusto">
                        {{ props.row.centrocusto }}
                    </span>
                    <span v-else-if="props.row.desFormapagto">
                        {{ props.row.desFormapagto.descricao }}
                    </span>
                    <span v-else>---</span>
                </div>

                <div v-else-if="f.key == 'valor'">
                    {{ props.row.valor | decimal(null, true) }}
                </div>

                <div v-else-if="f.key == 'valor-km'">
                    {{ props.row.valorkm | decimal(null, true) }}
                </div>
                
                <div v-else-if="f.key == 'forma_pagamento'">
                    <span v-if="props.row.desFormapagto">
                        {{ props.row.desFormapagto.descricao }}
                    </span>
                    <span v-else>---</span>
                </div>
                <!-- Componente para abrir modal de fotos -->
                <div 
                    v-else-if="f.key == 'fotos'" 
                    @click="openModalFotos(props.row)"
                    class="clickable"
                >
                    <b-icon 
                        v-if="props.row.qntFotos != 0"
                        class="has-badge-primary mt-1" 
                        icon="camera"
                        :data-badge="props.row.qntFotos"
                        v-tippy 
                        :title="$t('msg-tooltip-despesa-n-fotos', { n: props.row.qntFotos })"
                    /> 
                    <span v-else>---</span>
                </div>
            </b-table-column>

            <template slot="bottom-left">
                <div class="columns despesa-footer">
                    <th id="footer-1" class="column is-12">
                        <span>
                            {{ $t('registro') }}: {{ despesas.length }}  
                        </span>
                    </th>
                    <th id="footer-2" class="column is-12">
                        <span>
                            {{ $t('valor') }} {{ valorTotalDespesasDaPagina | decimal(null, true) }} 
                        </span>
                    </th>
                </div>
            </template>
        </b-table>

        <!-- Modal fotos da despesa -->
        <b-modal
            class="modal-default"
            :active.sync="isShowModalFotos"
            style="z-index: 1000"
            @close="closeModalFotos"
        >
            <!-- <ContainerLoader v-if="isLoadingPrint" /> -->
            <div class="modal-card-body">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <template>
                            <b-carousel
                                :pause-info="false"
                                :animated="'fade'"
                                :progress="true"
                            >
                                <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                                    <section :class="`hero is-medium is-${carousel.color}`">
                                        <div class="hero-body-img has-text-centered">
                                            <b-image
                                                :src="carousel.url"
                                                :responsive="true"
                                                class="image-control"
                                            />
                                        </div>
                                    </section>
                                </b-carousel-item>
                            </b-carousel>
                        </template>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import DespesaService from "@/services/despesas/DespesaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
    },
    props: {
        motivodespesa: {
            type: Object,
            default: () => {},
        },
        despesas: {
            type: Array,
            default: () => [],
        },
        propDespesasSelecionadas: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            carousels: [],
            fields: [
                {key: "data", width: 165, sortable: false, footer: false },
                {key: "empresa", width: 165, sortable: false, footer: false },
            ],
            pagination: {
                perPageOptions: [10, 25, 50, 100],
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
            },
            service: new DespesaService(this.$http, this.$router),
            valorTotalDespesasDaPagina: 0,
            isLoading: false,
            idusuario: Number(this.$route.params.userId),
            idacerto: Number(this.$route.query.acertoId),
            isChecked: false,
            totalAcerto: 0,
            fotosDespesa : [],
            isShowModalFotos: false,
        };
    },
    computed: {
        despesasSelecionadas: {
            get: function () {
                return this.propDespesasSelecionadas;
            },
            set: function (newValue) {
                this.$emit("despesas-selecionadas", newValue);
            },
        },
    },
    created() {
        this.permissao = this.hasPermissionAccess("despesas", "adicionar-despesas", "des-adicionar-despesas");
        if (!this.permissao.create){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'despesas' }
            });
        } else {
            //sync despesas selecionadas do componente pai para os filhos mudado para user keep-alive
            this.despesasSelecionadas = this.propDespesasSelecionadas

            this.buildFields();
            this.somarvalorTotalDespesasDaPagina();
        }
    },
    watch:{
        despesas: {
            deep: true,
            handler(){
                this.somarvalorTotalDespesasDaPagina()
            }
        }
    },
    methods: {
        buildFields() {
            Object.keys(this.motivodespesa).forEach((key) => {
                //POR HORA NÃO USAMOS FOTO NA LISTAGEM SE PRECISAR REMOVER SEGUNDA CONDIÇÃO
                if (
                    key.toLowerCase().indexOf("habilita") > -1 &&
                    key.toLowerCase() != "fotohabilita"
                ) {
                    if (this.motivodespesa[key]) {
                        this.fields.push({
                            key: key.split("habilita")[0],
                            sortable: false,
                            width: 100,
                        });
                    }
                }
                //Adicionar label de valor km
                if (key.toLowerCase().indexOf("despesas") > -1) {
                    if (this.motivodespesa[key][0].valorkm>0) {
                        this.fields.push({ key: "valor-km", width: 100, sortable: false });
                    }
                }
            });
            this.fields.push({ key: "valor", width: 150, sortable: false });
            this.fields.push({ key: "fotos", width: 50, sortable: false });
        },
        closeModalFotos(){
                this.carousels = [];
                this.isShowModalFotos = false;
        },
        openModalFotos(obj){
            // Chama o metodo que busca as fotos.
            setTimeout(() => {
                this.findAndPushFotosDespesa(obj)
            }, 200);

            this.isShowModalFotos = true;

        },
        somarvalorTotalDespesasDaPagina() {
            this.valorTotalDespesasDaPagina = 0;
            this.despesas.forEach((despesa) => {
                this.valorTotalDespesasDaPagina += despesa.valor;
            });
        },
        findAndPushFotosDespesa(obj){
                    this.service
                .findAllFotosDespesasByIdDespesa(obj.iddespesa)
                .then((r) => {
                    this.fotosDespesa = r.content;
                })
                .catch((e) => {
                    console.error("Erro ao carregar os fotos: " + e);
                })
                .finally(_ => {
                    this.fotosDespesa.forEach((foto) => {
                        this.carousels.push({
                            url: foto.caminho,
                            nome: foto.nome,
                        });
                    });
        })

        }
    },
};
</script>

<style lang="scss" scoped>
.margin-none {
    margin: 0 !important;
}

.b-checkbox {
    transform: scale(1.2);
}

#main,
.rodape-table-info {
    height: 100%;
}

.data-table{
    margin-bottom: 10rem !important;
}

.lps-table {
    padding-top: 0px;
    font-size: 14px;
}

.hero-body-img{
    padding:20px;
}

bg-footer {
    background-color: #f3f3f3 !important;
}

.center-checkbox {
    vertical-align: middle;
    text-align: center;
}

.width-4 {
    width: 20px;
}
</style>